<template>
<div class="container cf ph1 w-80-ns center">
  <div v-for="(image, i) in (mobile ? images : images.slice(0,imageCount-1))" :key="i">
    <div v-if="mobile" :class="[(i) % 5 == 0 ? 'w-100' : 'w-100', 'pa1']" >
      <div href="" class="db aspect-ratio aspect-ratio--1x1" >
        <span role="img" :style="{ backgroundImage: `url(${image.pathLong})` }" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
    <div v-else :class="[(i) % 5 == 0 ? 'w-100 w-50-ns' : 'w-50 w-25-ns', (i < imageCount/3 - 1) || (i > imageCount/3) ? 'fl' : 'fr',  'pa1']" >
      <div href="" class="db aspect-ratio aspect-ratio--1x1 ">
        <span role="img" :style="{ backgroundImage: `url(${image.pathLong})` }" class="bg-center cover aspect-ratio--object"></span>
      </div>
    </div>
  </div>
  <ScrollTopArrow v-if="mobile" />
</div>
</template>

<script>
import ScrollTopArrow from '@/components/ScrollTopArrow'
export default {
  name: 'Residential',
  props: ['mobile'],
  data() {
    return {
      current_img: 0,
      position: null,
      images: [
      ],
      imageCount: 0
    };
  },
  components: { ScrollTopArrow },
  methods: {
    importAll(r) {
      r.keys().forEach(key => (this.images.push({ pathLong: r(key), pathShort: key })));
    },
    next: function() {
      this.current_img += 1;
    },
    prev: function() {
      this.current_img -= 1;
      if (this.current_img < 0) {
        this.current_img = (this.images.length - 1);
      }
    }
  },
  mounted() {
    this.importAll(require.context('../assets/murietta/', true, /\.jpg$/));
    this.importAll(require.context('../assets/proj1/', true, /\.jpg$/));
    this.imageCount = this.images.length
    console.log(this.imageCount)
  },
};
</script>

<style scoped>
.bg-center {
    border: solid 1px white;
}
</style>
